import { AliasesAPI } from "./methods";
import { execute } from "../../apiCommandsExecutor";
import { ExecutionStatus } from "../general/requestsResponses";
import {
    CreateAliasBindingRequest,
    CreateAliasBindingResponse,
    GetAliasBindingsRequest,
    GetAliasBindingsResponse,
    GetMenuAliasBindingsRequest,
    GetMenuAliasBindingsResponse, GetPublicAliasBindingRequest, GetPublicAliasBindingResponse,
    UpdateAliasBindingRequest,
    UpdateAliasBindingResponse
} from "./requestsResponses";

export const createAlias = async (params:  CreateAliasBindingRequest) => {
    const response = await execute<CreateAliasBindingRequest, CreateAliasBindingResponse>(
        AliasesAPI.createAliasBinding, params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
    }
};

export const updateAlias = async (params:  UpdateAliasBindingRequest) => {
    const response = await execute<UpdateAliasBindingRequest, UpdateAliasBindingResponse>(
        AliasesAPI.updateAliasBinding, params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
    }
};

export const getAliases = async (params: GetAliasBindingsRequest) => {
    const response = await execute<GetAliasBindingsRequest, GetAliasBindingsResponse>(
        AliasesAPI.getAliasBindings, params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        aliases: response.data.aliasBindings
    }
};



export const getAliasesByMenuId = async (params: GetMenuAliasBindingsRequest) => {
    const response = await execute<GetMenuAliasBindingsRequest, GetMenuAliasBindingsResponse>(
        AliasesAPI.getAliasesByMenuId, params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        aliases: response.data.aliasBindings
    }
};


export const getPublicAliasBindingByAlias = async (params: GetPublicAliasBindingRequest) => {
    const response = await execute<GetPublicAliasBindingRequest, GetPublicAliasBindingResponse>(
        AliasesAPI.getPublicAliasBinding, params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        aliasBinding: response.data.aliasBinding
    }
};


